
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const whatsappMessage = encodeURIComponent('Merhaba, izmirvizedanismanlik.net web siteniz üzerinden yazıyorum.');
  const whatsappUrl = `https://wa.me/905422671171?text=${whatsappMessage}`;

  return (
    <footer className="bg-darkBlue text-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 400" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 200 Q 300 100 600 200 T 1200 200" stroke="currentColor" strokeWidth="1" />
          <path d="M0 250 Q 300 150 600 250 T 1200 250" stroke="currentColor" strokeWidth="1" />
          <circle cx="200" cy="100" r="50" stroke="currentColor" strokeWidth="1" fill="none" />
          <circle cx="800" cy="300" r="70" stroke="currentColor" strokeWidth="1" fill="none" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Column 1: Logo & Info */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img
                src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/1f181de74aaa931a1d401b754fc739f4.png"
                alt="İzmir Vize Danışmanlık"
                className="h-14 w-auto mb-2"
                loading="lazy"
              />
            </Link>
            <p className="font-body text-sm text-gray-300">
              İzmir'in en güvenilir vize danışmanlık merkezi. %98 başarı oranı ile hizmetinizdeyiz.
            </p>
            <div className="space-y-3">
              <p className="font-body text-sm flex items-start space-x-2">
                <i className="ri-map-pin-line text-secondary mt-1 flex-shrink-0"></i>
                <span>Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı, Konak/İzmir</span>
              </p>
              <p className="font-body text-sm flex items-center space-x-2">
                <i className="ri-phone-line text-secondary"></i>
                <a href="tel:+905422671171" className="hover:text-secondary transition-colors">
                  +90 542 267 11 71
                </a>
              </p>
              <p className="font-body text-sm flex items-center space-x-2">
                <i className="ri-whatsapp-line text-secondary"></i>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="hover:text-secondary transition-colors">
                  WhatsApp
                </a>
              </p>
              <p className="font-body text-sm flex items-center space-x-2">
                <i className="ri-mail-line text-secondary"></i>
                <a href="mailto:info@izmirvizedanismanlik.net" className="hover:text-secondary transition-colors">
                  info@izmirvizedanismanlik.net
                </a>
              </p>
            </div>
          </div>

          {/* Column 2: Hızlı Linkler */}
          <div>
            <h4 className="font-heading font-bold text-sm mb-4 uppercase tracking-wide">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/ulkeler" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Ülkeler
                </Link>
              </li>
              <li>
                <Link to="/blog" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Hizmetler */}
          <div>
            <h4 className="font-heading font-bold text-sm mb-4 uppercase tracking-wide">Hizmetlerimiz</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/hizmetler" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Schengen Vizesi
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Amerika Vizesi
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  İngiltere Vizesi
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Oturum Kartı
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Göçmenlik Danışmanlığı
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Yasal */}
          <div>
            <h4 className="font-heading font-bold text-sm mb-4 uppercase tracking-wide">Yasal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/kvkk" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  KVKK
                </Link>
              </li>
              <li>
                <Link to="/cerez-politikasi" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Çerez Politikası
                </Link>
              </li>
              <li>
                <Link to="/sss" className="font-body text-sm text-gray-300 hover:text-secondary transition-colors">
                  Sıkça Sorulan Sorular
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="font-body text-sm text-gray-400">
            © {currentYear} İzmir Vize Danışmanlık. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center space-x-4">
            <Link to="/kvkk" className="font-body text-sm text-gray-400 hover:text-secondary transition-colors">
              KVKK
            </Link>
            <span className="text-gray-600">•</span>
            <Link to="/cerez-politikasi" className="font-body text-sm text-gray-400 hover:text-secondary transition-colors">
              Çerez Politikası
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
